<script>
import { mapState } from 'vuex'
import {
  SET_COMPANY_INVOICES_CURRENT_PAGE_NUMBER,
  SET_COMPANY_INVOICES_FILTER_INVOICE_DATE, SET_COMPANY_INVOICES_FILTER_INVOICE_MONTH,
  SET_COMPANY_INVOICES_FILTER_INVOICE_NUMBER, SET_COMPANY_INVOICES_FILTER_INVOICE_YEAR
} from '../../store/modules/invoice/mutation-types'
import InvoiceFilterBaseForm from './InvoiceFilterBaseForm'
import { parseStoreDate } from '../../utils/date'

export default {
  name: 'InvoiceFilterForm',
  extends: InvoiceFilterBaseForm,
  computed: {
    ...mapState({
      invoiceNumber: state => state.invoice.companyInvoicesFilterInvoiceNumber,
      invoiceDate: state => parseStoreDate(state.invoice.companyInvoicesFilterInvoiceDate),
      invoiceMonth: state => state.invoice.companyInvoicesFilterInvoiceMonth,
      invoiceYear: state => state.invoice.companyInvoicesFilterInvoiceYear
    })
  },
  methods: {
    setInvoiceNumber: function (value) {
      this.$store.commit(`invoice/${SET_COMPANY_INVOICES_FILTER_INVOICE_NUMBER}`, value)
    },
    setInvoiceDate: function (value) {
      this.$store.commit(`invoice/${SET_COMPANY_INVOICES_FILTER_INVOICE_DATE}`, value)
    },
    setInvoiceMonth: function (value) {
      this.$store.commit(`invoice/${SET_COMPANY_INVOICES_FILTER_INVOICE_MONTH}`, value)
    },
    setInvoiceYear: function (value) {
      this.$store.commit(`invoice/${SET_COMPANY_INVOICES_FILTER_INVOICE_YEAR}`, value)
    },
    filter: function () {
      this.$store.commit(`invoice/${SET_COMPANY_INVOICES_CURRENT_PAGE_NUMBER}`, { number: 0 })
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/InvoiceFilterForm.vue